// extracted by mini-css-extract-plugin
export default {"row":"OverviewPageFundSelector_row__74Unv"};